import {
    signInWithEmailAndPassword,
    signInWithCustomToken,
    signOut,
    User,
    UserCredential,
} from 'firebase/auth';
import { auth } from '../config/firebase';

export interface FirebaseLoginRequest {
    email: string;
    password: string;
}

export interface FirebaseCustomTokenRequest {
    customToken: string;
}

export const firebaseAuthApi = {
    // 이메일/비밀번호 로그인
    loginWithEmailPassword: async (
        credentials: FirebaseLoginRequest
    ): Promise<UserCredential> => {
        try {
            const userCredential = await signInWithEmailAndPassword(
                auth,
                credentials.email,
                credentials.password
            );
            return userCredential;
        } catch (error) {
            throw new Error((error as Error).message || '로그인에 실패했습니다.');
        }
    },

    // 커스텀 토큰으로 로그인
    loginWithCustomToken: async (
        request: FirebaseCustomTokenRequest
    ): Promise<UserCredential> => {
        try {
            const userCredential = await signInWithCustomToken(
                auth,
                request.customToken
            );
            return userCredential;
        } catch (error) {
            throw new Error((error as Error).message || '커스텀 토큰 로그인에 실패했습니다.');
        }
    },

    // 현재 사용자의 ID 토큰 가져오기
    getCurrentUserToken: async (forceRefresh = false): Promise<string> => {
        const user = auth.currentUser;
        if (!user) {
            throw new Error('로그인된 사용자가 없습니다.');
        }
        return await user.getIdToken(forceRefresh);
    },

    // 로그아웃
    logout: async (): Promise<void> => {
        await signOut(auth);
    },

    // 현재 사용자 정보
    getCurrentUser: (): User | null => {
        return auth.currentUser;
    },

    // 인증 상태 변경 리스너
    onAuthStateChanged: (callback: (user: User | null) => void) => {
        return auth.onAuthStateChanged(callback);
    },
};
